import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@copro/api';
import { useSpace } from '../../../hooks/useSpace';
import { useAuth } from '../../../hooks/useAuth';
import { keys } from './keys';

async function fetchUnreadCount(spaceId: string, userId: string) {
  const { count, error } = await apiClient
    .from('notifications')
    .select('id', { count: 'exact', head: true })
    .eq('space_id', spaceId)
    .eq('user_id', userId)
    .is('read_at', null);

  if (error) {
    throw error;
  }

  return count ?? 0;
}

export default function useGetUnreadCount() {
  const { currentSpace } = useSpace();
  const { user } = useAuth();

  return useQuery({
    queryKey: keys.unreadCount(),
    queryFn: () => fetchUnreadCount(currentSpace!.id, user!.id),
    enabled: !!currentSpace?.id && !!user?.id,
  });
}
